// Helper coins (students only): 1 coin = 1 helper message. A student's coins for today are the daily
// limit plus the teacher's extra for today, less what's used (apps/api guardrails.ts helperCoins).
// Teachers have no limit and see no coins. Plain words for grade 8 reading level.

/** At this many coins or fewer, the counter turns salmon and says how many are left. */
export const LOW_COINS = 5;

/** The counter's text: "× 37" normally, "3 coins left" when low. */
export function coinCountText(left: number): string {
  return left <= LOW_COINS ? `${left} ${left === 1 ? "coin" : "coins"} left` : `× ${left}`;
}

/** The tooltip and screen-reader label. */
export function coinAria(left: number): string {
  return `${left} helper ${left === 1 ? "coin" : "coins"} left today. Each message to the helper uses 1 coin.`;
}

// The coin sprite: an 8×8 pixel coin, gold with a darker rim, drawn the way the lion is (lion-sprites.ts).
// "." is see-through.
export const COIN_PALETTE: Record<string, string> = {
  R: "#b8791f", // rim (the darker gold)
  H: "#ffd98a", // highlight
  G: "#f0ad42", // CHA Gold: face
  D: "#d9962f", // shade on the lower right
};

export const COIN_GRID: string[] = ["..RRRR..", ".RHGGGR.", "RHGGGGDR", "RGGGGGDR", "RGGGGGDR", "RGGGGDDR", ".RGGDDR.", "..RRRR.."];

/** Horizontal runs of one colour, so the SVG has a few dozen rects, not one per pixel. */
export function coinRuns(grid: string[] = COIN_GRID, palette: Record<string, string> = COIN_PALETTE): { x: number; y: number; w: number; c: string }[] {
  const runs: { x: number; y: number; w: number; c: string }[] = [];
  grid.forEach((row, y) => {
    let x = 0;
    while (x < row.length) {
      const ch = row[x]!;
      let end = x + 1;
      while (end < row.length && row[end] === ch) end++;
      if (ch !== ".") runs.push({ x, y, w: end - x, c: palette[ch] ?? "#f0f" });
      x = end;
    }
  });
  return runs;
}
